import { useEffect } from 'react';

export const useQualtrics = (shouldRun: any) => {
    useEffect(() => {
        if (shouldRun) {
            window.QSI?.API?.unload();
            window.QSI?.API?.load()?.then(window.QSI?.API?.run);
        }
    }, [shouldRun]);
};
